import { setPasswordApi } from "@/api/services/main/auth";
import { Button } from "@/components/elements/Button";
import { Checkbox } from "@/components/elements/Checkbox";
import { Form } from "@/components/elements/Form";
import { FormField } from "@/components/elements/FormField";
import { Input } from "@/components/elements/Input";
import { Linkable } from "@/components/elements/Linkable";
import { registerSchema } from "@/features/auth/schema/registerSchema";
import { TRegisterForm } from "@/features/auth/types/registerForm";
import { TRegisterQuery } from "@/features/auth/types/registerQuery";
import { AppRoutes } from "@/routes/config";
import { setErrorForm, showError } from "@/utils/error";
import { getQueryFromURL } from "@/utils/url";
import { yupResolver } from "@hookform/resolvers/yup";
import { Stack, Typography } from "@mui/material";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";

const initForm: TRegisterForm = {
  email: "",
  newPassword: "",
  confirmNewPassword: "",
  companyCode: "",
};

export const RegisterForm = () => {
  const query = getQueryFromURL<TRegisterQuery>();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [agree, setAgree] = useState(false);
  const methods = useForm<TRegisterForm>({
    mode: "all",
    reValidateMode: "onBlur",
    defaultValues: { ...initForm, email: query?.email ?? "", companyCode: query?.companyCode ?? "" },
    resolver: yupResolver(registerSchema),
  });
  const { control } = methods;

  const onSubmit = async (data: TRegisterForm) => {
    const { newPassword } = data;
    if (!query) return;
    const { email, resetToken, companyCode } = query;
    try {
      if (email && resetToken) {
        await setPasswordApi({ email, newPassword, resetToken, companyCode });
        const params = new URLSearchParams({
          email,
          companyCode,
        });
        navigate(`${AppRoutes.registerComplete}?${params.toString()}`);
      }
    } catch (error) {
      showError(error);
      setErrorForm(methods, error);
    }
  };

  const isRegisterRoute = pathname === AppRoutes.register;

  return (
    <Form methods={methods} onSubmit={onSubmit} enableBlocker={false} schema={registerSchema}>
      <Stack gap={3} width={400}>
        <FormField control={control} name="companyCode">
          <Input disabled size="lg" />
        </FormField>
        <FormField control={control} name="email">
          <Input disabled size="lg" />
        </FormField>
        <FormField control={control} name="newPassword">
          <Input type="password" size="lg" />
        </FormField>
        <FormField control={control} name="confirmNewPassword">
          <Input type="password" size="lg" />
        </FormField>
        <Typography variant="body14" color={"#5A6063"}>
          ※パスワードはアルファベット大文字・小文字・数字・記号を含む12文字以上で入力してください。
        </Typography>
        <Checkbox
          label={
            <Stack direction={"row"}>
              <Linkable href="https://iro-hana.com/privacy/" color="#1890FF" target="_blank">
                プライバシーポリシー
              </Linkable>
              に同意します。
            </Stack>
          }
          onChange={(e) => setAgree(e.target.checked)}
        />
        <Button type="submit" variant="primary" disabled={!agree} fullWidth>
          {isRegisterRoute ? "新規登録する" : "パスワードを再発行"}
        </Button>
      </Stack>
    </Form>
  );
};
